module.exports = __webpack_public_path__ + "img/export_pdf_arrow-24px.c3a55510.svg";